/**
 * Environment variables read from the build-time configuration.
 */
export const Env = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  MODE: process.env.NODE_ENV || "development",
  MEDIA_URL: process.env.REACT_APP_MEDIA_UPLOAD_URL,
  POSTHOG_HOST: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "",
  POSTHOG_KEY: process.env.REACT_APP_PUBLIC_POSTHOG_KEY || "",
  REVERSE_PROXY_TARGET: process.env.REACT_APP_REVERSE_PROXY_TARGET || "",
  CHAIN_ID: process.env.REACT_APP_CHAIN_ID || "",
  ENVIRONMENT_ID: process.env.REACT_APP_DYNAMIC_ENVIRONMENT_ID || "",
  USER_AUTHENTICATION_EMAIL: process.env.REACT_APP_USER_AUTHENTICATION_EMAIL,
  USER_AUTHENTICATION_PASSWORD:
    process.env.REACT_APP_USER_AUTHENTICATION_PASSWORD,
  IPFS_GATEWAY_URL: process.env.REACT_APP_IPFS_GATEWAY_URL || "",
  API_KEY: process.env.REACT_APP_API_KEY || "",
  MAINNET_RPC_URL:
    process.env.REACT_APP_MAINNET_RPC_URL || "https://cloudflare-eth.com",
  AMOY_RPC_URL:
    process.env.REACT_APP_AMOY_RPC_URL || "https://polygon-amoy.drpc.org",
  VALID_SCAN_DOMAINS:
    "localhost,db-consumer-dev.appskeeper.in,db-consumer-qa.appskeeper.in,preprod-app.databis.io,app.databis.io".split(
      ",",
    ),
  API_TIMEOUT: 30000,
  SUPPORT_EMAIL: "support@databis.io",
  SUPPORT_PORTAL: "https://support.databis.io",
  WEBSITE: "https://www.databis.io",
  APP_VERSION: process.env.REACT_APP_VERSION_NAME || "1.1.0",
} as const;
